import { render, staticRenderFns } from "./pointSelector.vue?vue&type=template&id=0f9d5e40&scoped=true&"
import script from "./pointSelector.vue?vue&type=script&lang=js&"
export * from "./pointSelector.vue?vue&type=script&lang=js&"
import style0 from "./pointSelector.vue?vue&type=style&index=0&id=0f9d5e40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9d5e40",
  null
  
)

export default component.exports